"use client";

import RemoveAllIcon from "@/app/assets/images/svg/rotate.svg";
import RemoveIcon from "@/app/assets/images/svg/xmark.svg";
import { useI18n } from "@/i18n/client";
import { SearchFacet, SearchFacetOption } from "@/lib/_search-providers/types";
import Link from "@/components/UI/Link/Link";
import { FC, useMemo, useState } from "react";
import styles from "./ActiveFilters.module.scss";
import { useSearchContext } from "@/components/_Search/provider/SearchContextProvider";

export interface ActiveFiltersProps {}

const ActiveFilters: FC<ActiveFiltersProps> = () => {
	const t = useI18n();

	const { links, facets } = useSearchContext();

	const [activeFacets, setActiveFacets] = useState<SearchFacet[]>(
		facets.options.map((facet) => {
			return {
				...facet,
				options: facet.options.filter((option) => option.isActive),
			};
		}),
	);

	const activeFilterCount = useMemo(() => {
		return activeFacets.reduce((acc, facet) => acc + facet.options.length, 0);
	}, [activeFacets]);

	const handleRemoveFacet = (facet: SearchFacet, option: SearchFacetOption) => {
		// remove the option from the facet in context
		facets.updateFacet(facet.value, option.value, false);

		// check local state for facet and remove option if found
		let updatedFacets = [...activeFacets];

		const facetToChange = updatedFacets.find((f) => f.value === facet.value);

		if (!facetToChange) {
			return;
		}
		// remove the option from the facet in local state
		facetToChange.options = facetToChange.options.filter(
			(o) => o.value !== option.value,
		);

		if (facetToChange.options.length === 0) {
			// remove the facet from the local state
			updatedFacets = updatedFacets.filter((f) => f.value !== facet.value);
		}

		// update local state
		setActiveFacets(updatedFacets);
	};

	if (activeFilterCount === 0) {
		return null;
	}

	return (
		<div className={styles.container}>
			<h3 className={styles.title}>
				{t("Search.selectedFilters")} ({activeFilterCount})
			</h3>
			<>
				<Link href={links.clearAll} className={styles.removeAll}>
					<RemoveAllIcon />
					{t("Search.clearFilters")}
				</Link>

				<div className={styles.filters}>
					{activeFacets.map((facet) => {
						return facet.options.map((option) => {
							const key = `${facet.value}:${option.value}`;
							return (
								<button
									key={key}
									type='button'
									className={styles.removeFilter}
									onClick={() => handleRemoveFacet(facet, option)}
								>
									{option.label} <RemoveIcon />
								</button>
							);
						});
					})}
				</div>
			</>
		</div>
	);
};

export default ActiveFilters;
